import * as r from '@recoiljs/refine';
import { atom, DefaultValue } from 'recoil';
import { urlSyncEffect } from 'recoil-sync';

export interface ChartFilterAtom {
	companies: string[];
	boards: string[];
	managements: string[];
	coordinations: string[];
	employees: string[];
	positionFilter?: number;
}

const stringArrayChecker = r.array(r.string()) as r.Checker<string[]>;

const sameSideFilters = (a: ChartFilterAtom, b: ChartFilterAtom) =>
	a.companies === b.companies &&
	a.boards === b.boards &&
	a.managements === b.managements &&
	a.coordinations === b.coordinations &&
	a.employees === b.employees;

export const chartAtom = atom<ChartFilterAtom>({
	key: 'chart',
	default: {
		companies: [],
		boards: [],
		managements: [],
		coordinations: [],
		employees: [],
		positionFilter: undefined,
	},
	effects: [
		urlSyncEffect<ChartFilterAtom>({
			refine: r.object({
				companies: stringArrayChecker,
				boards: stringArrayChecker,
				managements: stringArrayChecker,
				coordinations: stringArrayChecker,
				employees: stringArrayChecker,
				positionFilter: r.optional(r.number()),
			}),
			history: 'push',
		}),
		({ onSet, setSelf }) => {
			onSet((newValue, oldValue) => {
				if (oldValue instanceof DefaultValue) return;

				if (
					newValue.positionFilter !== undefined &&
					newValue.positionFilter === oldValue.positionFilter &&
					!sameSideFilters(newValue, oldValue)
				) {
					setSelf({ ...newValue, positionFilter: undefined });
				}
			});
		},
	],
});
